import { jsxs as a, jsx as n } from "react/jsx-runtime";
import { Button as C } from "../Button/Button.js";
import { Wrapper as d, Divider as P, ProgramAgencyContainer as b, AgenciesTitle as m, AgencyLogo as g, PartnerAgenciesContainer as j, AgenciesGroup as x, FillActionsContainer as y, ActionsContainer as L } from "./styled.js";
const T = {
  left: d.LeftAligned,
  justify: d.JustifyAligned
}, B = ({
  programOfAgency: e,
  programOfAgencyTitle: h,
  partnershipWithAgencies: r = [],
  partnershipWithAgenciesTitle: f,
  actions: t = [],
  agencyAlignment: s = "left"
}) => {
  const u = T[s], A = s === "left" ? y : L, p = r && r.length > 0;
  return /* @__PURE__ */ a(u, { children: [
    /* @__PURE__ */ n(A, { children: t && t.length > 0 && t.map((i) => {
      const { id: l, label: o, onClick: c } = i;
      return /* @__PURE__ */ n(C, { onClick: c, children: o }, l);
    }) }),
    /* @__PURE__ */ n(P, {}),
    /* @__PURE__ */ a(b, { children: [
      /* @__PURE__ */ n(m, { children: h }),
      e && /* @__PURE__ */ n(g, { children: /* @__PURE__ */ n("img", { src: e.image, alt: e.label }) })
    ] }),
    p && /* @__PURE__ */ a(j, { children: [
      /* @__PURE__ */ n(m, { children: f }),
      /* @__PURE__ */ n(x, { children: r.map((i) => {
        const { id: l, label: o, image: c } = i;
        return /* @__PURE__ */ n(g, { children: /* @__PURE__ */ n("img", { src: c, alt: o }) }, l);
      }) })
    ] })
  ] });
};
export {
  B as TransactionActionPanel,
  B as default
};
